// extracted by mini-css-extract-plugin
export default {"breakAll":"Text_breakAll__HXAxX"};